import { z } from "zod";
import {
  dateFilterSchema,
  optionalIngestedDateFilterSchema
} from "../agents/customerInteractionFilters.js";
import { withErrorToolOutput } from "../agents/errorToolOutput.js";
import {
  AutomationDeliveryProvider,
  automationDeliveryProviderSchema
} from "./automation.js";
import { teammateIdSchema } from "./teammate.js";
const MANAGER_REPORT_PLAN_TOOL_ID = "plan_reports";
const MANAGER_REPORT_DELEGATE_TOOL_ID = "generate_report";
const MANAGER_REPORT_NOTIFY_TOOL_ID = "send_notifications";
const managerReportPlanInputSchema = z.object({
  date: dateFilterSchema,
  ingested_date: optionalIngestedDateFilterSchema
});
const managerReportPlanOutputSchema = withErrorToolOutput(
  z.object({
    recipients: z.array(
      z.object({
        teammate_id: teammateIdSchema,
        name: z.string()
      })
    )
  })
);
const managerReportDelegateInputSchema = z.object({
  recipient_teammate_id: teammateIdSchema
});
const managerReportDelegateOutputSchema = withErrorToolOutput(
  z.object({
    status: z.enum(["saved", "not_planned"]),
    is_empty: z.boolean().optional(),
    message: z.string().optional()
  })
);
const managerReportNotifyOutputSchema = withErrorToolOutput(
  z.object({
    status: z.enum(["sent", "failed"]),
    emailed_recipient_teammate_ids: z.array(teammateIdSchema),
    skipped_empty_recipient_teammate_ids: z.array(teammateIdSchema),
    /** Reports whose recipient no longer resolves — released, not failed. */
    unresolved_recipient_teammate_ids: z.array(teammateIdSchema),
    /**
     * Recipients whose email matched no user at the chat provider — the DM was
     * skipped and settled, not retried. Carries the email so the run
     * transcript can name exactly who was skipped, even if the teammate is
     * later deleted. Defaulted so transcripts recorded before chat delivery
     * still parse.
     */
    recipients_without_chat_user: z.array(z.object({ teammate_id: teammateIdSchema, email: z.string() })).default([]),
    failed_recipient_teammate_ids: z.array(teammateIdSchema),
    /** Subscribers CC'd on each notification, for the progress row's label. */
    subscriber_count: z.number(),
    /**
     * Channel delivery: how many channel posts this run delivered
     * (reports × channels). Defaulted so older transcripts still parse.
     */
    channel_post_count: z.number().default(0),
    /**
     * The run's delivery provider, so the transcript stays self-describing
     * (progress rows label skips and posts with the provider). Defaulted for
     * transcripts recorded before delivery config existed.
     */
    delivery_provider: automationDeliveryProviderSchema.default(
      AutomationDeliveryProvider.EMAIL
    )
  })
);
function buildEmptyManagerReportNotifyOutput(deliveryProvider) {
  return {
    status: "sent",
    emailed_recipient_teammate_ids: [],
    skipped_empty_recipient_teammate_ids: [],
    unresolved_recipient_teammate_ids: [],
    recipients_without_chat_user: [],
    failed_recipient_teammate_ids: [],
    subscriber_count: 0,
    channel_post_count: 0,
    delivery_provider: deliveryProvider
  };
}
function buildRecipientThreadId(automationRunId, recipientTeammateId) {
  return `${automationRunId}:${recipientTeammateId}`;
}
export {
  MANAGER_REPORT_DELEGATE_TOOL_ID,
  MANAGER_REPORT_NOTIFY_TOOL_ID,
  MANAGER_REPORT_PLAN_TOOL_ID,
  buildEmptyManagerReportNotifyOutput,
  buildRecipientThreadId,
  managerReportDelegateInputSchema,
  managerReportDelegateOutputSchema,
  managerReportNotifyOutputSchema,
  managerReportPlanInputSchema,
  managerReportPlanOutputSchema
};
//# sourceMappingURL=managerReportOrchestration.js.map
